/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, memo, PropsWithChildren } from 'react';

interface IPortalPlaceholderProps extends PropsWithChildren {
  id: string;
}
export const PortalPlaceholder: FC<IPortalPlaceholderProps> = memo(
  ({ id, children }) => <div id={id}>{children}</div>
);
PortalPlaceholder.displayName = 'PortalPlaceholder';

export default PortalPlaceholder;
